import WebResponse from "helpers/WebResponse";
import { ICADModel, IEdgeElbow, IEdgeRake, IEdgeShift, IWithLayer } from "../../interfaces";
import APIHelper from "helpers/APIHelper";

export class EdgeToolAPI {

    public static PostEdgeShift(layer: string, edgeName: string, offset: number): Promise<WebResponse<ICADModel>> {

        const shift: IEdgeShift & IWithLayer = { layer, edgeName, offset };
        return APIHelper.PostAsync<ICADModel>(`api/cad/item/shifts`, undefined, shift, false);

    }

    public static PostEdgeRake(layer: string, edgeName: string, offset: number, rakeStart: boolean) {

        const rake: IEdgeRake& IWithLayer = { layer, edgeName, offset, rakeStart: rakeStart};
        return APIHelper.PostAsync<ICADModel>(`api/cad/item/rakes`, undefined, rake, false);

    }

    public static PostEdgeElbow(layer: string, edgeName: string, startFixed: boolean, breakDistance: number, breakOffset: number, oppositeOffset: number) {

        const elbow: IEdgeElbow& IWithLayer = { layer, edgeName, startFixed, breakDistance, breakOffset, overallOffset: oppositeOffset};
        return APIHelper.PostAsync<ICADModel>(`api/cad/item/elbows`, undefined, elbow, false);

    }


}
